import { createSelector } from "@reduxjs/toolkit"

import type { RootState } from "@/store/store"

const selectMeetingSessionDetailsMap = (state: RootState) =>
  state.meetingSessionDetails.meetingSessionDetails

export const selectMeetingSessionDetails = (sessionId: string) =>
  createSelector(
    selectMeetingSessionDetailsMap,
    (meetingSessionDetails) =>
      meetingSessionDetails[sessionId]?.meetingSessionDetails ?? null,
  )

export const selectMeetingSessionDetailsLastUpdated = (sessionId: string) =>
  createSelector(
    selectMeetingSessionDetailsMap,
    (meetingSessionDetails) =>
      meetingSessionDetails[sessionId]?.lastUpdated ?? null,
  )
